<template>
  <div class="space-y-6">
    <!-- Page header -->
    <div>
      <h1 class="text-3xl font-bold">Symbol Details</h1>
      <p class="text-muted-foreground">Detailed analysis for {{ symbol }}</p>
    </div>

    <!-- Stock Chart -->
    <div class="rounded-md border p-4">
      <CandlestickChart :symbol="symbol" @remove="onRemoveChart" />
    </div>

    <!-- Forecast and Risk Panels -->
    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <ForecastPanel :symbol="symbol" :horizon="5" />
      <RiskPanel :symbol="symbol" />
    </div>

    <!-- Backtest Panel -->
    <BacktestPanel :symbol="symbol" :weeks="104" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import CandlestickChart from "@/components/CandlestickChart.vue";
import ForecastPanel from "@/components/ForecastPanel.vue";
import RiskPanel from "@/components/RiskPanel.vue";
import BacktestPanel from "@/components/BacktestPanel.vue";

const route = useRoute();
const router = useRouter();
const symbol = computed(() => route.params.id as string);

// Handle chart removal by navigating back to positions
const onRemoveChart = () => {
  router.push("/");
};
</script>
